module.exports = __webpack_public_path__ + "img/login_web_bg.1f3fd7df.png";